export default __webpack_public_path__ + "static/media/17.7e5cdff1.jpg";